export default (
	value, moduleId, moduleKey, fieldId, actionFn, action, setLoading,
) => async (e) => {
	e.preventDefault()
	try {
		if (setLoading) setLoading(true)
		await actionFn(action, { moduleKey, moduleId, value })
	} catch (err) {
		throw err
	} finally {
		if (setLoading) setLoading(false)
	}
}
